jQuery(document).ready(function($) {    

    /**
     * New reviews code to allow for adding other providers in the yes/no chain easier. 
     * Take a look at http://klamathfallshonda.dev.dealerinspire.com/about-us/reviews/ for an example
     * 
     * Example: To add twitter, simply just add data-review="twitter" to the 2 Y and N inputs.
     *     <h3>Do you have a twitter account?</h3>
     *     <input id="twitter_Y" data-review="twitter" name="twitter" type="radio" value="Y" /><label for="twitter_Y">Yes</label>
     *     <input id="twitter_N" data-review="twitter" name="twitter" type="radio" value="N" /><label for="twitter_N">No</label>
     *     
     *     <div class="twitter twitter_Y">CLICK HERE TO PROCEED TO TWITTER</div>
     *     <div class="twitter twitter_N">Leave a review on cars.com?</div>
     *     
     * eOF: Example
     * @param  {[type]} $('#reviews input[data-review]').length [description]
     * @return {[type]}             [description]
     */
    
    if( $('#reviews input[data-review]').length ){
        $('#reviews input[data-review]').click(function() {
            var review_site = $(this).data('review');                               
            var carscom_val = $('#reviews input[name="' + review_site + '"]:checked').val();

            $('#reviews .' + review_site).hide();

            if($('#reviews .' + review_site + '.' + review_site + '_N').hasClass('skip')) {
                $('#reviews .' + review_site + '.' + review_site + '_N > h3, #reviews .' + review_site + '.' + review_site + '_N > p').hide();
                $('#reviews .' + review_site + '.' + review_site + '_N').css({background: 'none'});
                $('#reviews .' + review_site + '.' + review_site + '_N').show();
            }

            $('#reviews .'+ review_site + '_' + carscom_val).show();

            $('#reviews .' + review_site + ' input:checked').removeAttr('checked');
        });        
    }


	$('#reviews input[name="leave_review"]').click(function() {
		var leave_review_val = $('#reviews input[name="leave_review"]:checked').val();

		$('#reviews .leave_review, #reviews .google, #reviews .yelp').hide();
		$('#reviews .leave_review_'+leave_review_val).show();

		$('#reviews .leave_review input:checked').removeAttr('checked');
	});

	$('#reviews input[name="google"]').click(function() {
		var google_val = $('#reviews input[name="google"]:checked').val();
		$('#reviews .google').hide();

		if($('#reviews .google.google_N').hasClass('skip')) {
			$('#reviews .google.google_N > h3, #reviews .google.google_N > p').hide();
			$('#reviews .google.google_N').css({background: 'none'});
			$('#reviews .yelp_N').show();
		}

		$('#reviews .google_'+google_val).show();

		$('#reviews .google input:checked').removeAttr('checked');
	});

	$('#reviews input[name="yelp"]').click(function() {
		var yelp_val = $('#reviews input[name="yelp"]:checked').val();
		$('#reviews .yelp').hide();
		$('#reviews .yelp_'+yelp_val).show();

		$('#reviews .yelp input:checked').removeAttr('checked');
	});

	
    /* bOF: Pretty review buttons */    
    $.each($('#reviews input[type=radio]'), function(i,el){
        var ipt_name = $(el).attr('name');        
        $('#reviews input[name=' + ipt_name + '], #reviews label[for^=' + ipt_name + ']').css('display', 'none');

        if( !$('.btn--'+ipt_name).length )
            $('input[id='+ ipt_name +'_Y]').after('<button class="button btn--'+ ipt_name +'" value="yes">Yes</button><button class="button btn--'+ ipt_name +'" value="no">No</button>');

        $('body').on('click', '.btn--' + ipt_name, function(e){
            e.preventDefault();
            $('.btn--' + ipt_name).removeClass('primary-button');

            if( $(this).val() === 'yes' ){                        
                $('input[id='+ipt_name+'_Y]').prop('checked', true).trigger('click');
            }else{
                $('input[id='+ipt_name+'_N]').prop('checked', true).trigger('click');
            }

            $(this).addClass('primary-button');
        });

    });
    /* eOF: Pretty review buttons */

});